/** Espelha db_vendas.tipo_valor_declarado_expedicao. */
export enum TipoValorDeclaradoExpedicaoEnum {
    SemValorDeclarado = 1,
    ValorInformadoVendaOuTotalProdutos = 2,
}
